import { userAPI } from '@/services-ts/axios'
import type { IPayloadCompanySetting } from '@/types/Request'
import type { ILocationStore } from '@/types/Store/State'
import { defineStore } from 'pinia'
import {
  createSimpleListItem,
  deleteSimpleListItem,
  fetchSimpleList,
  updateSimpleListItem,
} from './simpleListHelpers'

export const useLocationStore = defineStore('location', {
  state: (): ILocationStore => ({
    locationList: [],
  }),

  actions: {
    async GetLocationList() {
      const list = await fetchSimpleList(() => userAPI.LocationServices.GetLocationList())
      if (list) this.locationList = list
    },

    async CreateLocation(Name: string) {
      const item = await createSimpleListItem(
        name => userAPI.LocationServices.CreateLocation(name),
        Name,
      )
      if (item) this.locationList.push(item)
      return !!item
    },

    async UpdateLocation(payload: IPayloadCompanySetting) {
      const status = await updateSimpleListItem(
        p => userAPI.LocationServices.UpdateLocation(p),
        payload,
      )
      if (status) {
        this.locationList = this.locationList.map(location =>
          location.id === payload.Id
            ? { ...location, name: payload.Name, firstValue: payload.Name }
            : location,
        )
      }
      return status
    },

    async DeleteLocation(Id: string) {
      const status = await deleteSimpleListItem(
        id => userAPI.LocationServices.DeleteLocation(id),
        Id,
      )
      if (status) {
        this.locationList = this.locationList.filter(location => location.id !== Id)
      }
    },
  },
})
